var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-history-page"},[_c('side-sessions',{on:{"selectSession":function($event){_vm.selectedSession = $event}}}),(_vm.selectedSession._id)?_c('single-session-data',{attrs:{"selected-session":_vm.selectedSession}}):_vm._e(),_c('attributes-list',{attrs:{"selected-session":_vm.selectedSession}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }